/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { displayScreen } from 'redux/actions/screen_status';
import { resetPointsBar } from 'redux/actions/rewards';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import AnswerErrorScreen from 'components/screens/answererror/answererror';
import { batchActions } from 'redux-batched-actions';



/* ========== ~~~~~~~~~~ ANSWER ERROR SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, embedStatus, rewards, sessionStatus }, { contentId }) => ({
    contentType: contentStatus[contentId]['type'],
    inView: embedStatus.inView,
    monetaryValue: rewards.settings.monetaryValue,
    // below added for tracking
    currentContentDataLength: contentData[contentId].data.length,
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    rewardsSettings: rewards.settings,
    embedStatus,
    embedSettings: settings.embedSettings,
    settings: settings,
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
});

// map actions
const mapDispatchToProps = dispatch => ({
    displayScreen: (screen) => dispatch(displayScreen(screen))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerErrorScreen);
